import { css } from '@emotion/core';

export const warningText = (theme) => css`
  font-size: ${theme && theme.getFontSize(1, 'px')};
  font-family: ${theme && theme.getFont()};
  color: ${theme && theme.getColor('text')};
  width: 100%;
  text-align: center;
`;
